// 백엔드 MIME_TO_EXTENSION의 이미지 항목과 일치
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

export const ACCEPTED_VIDEO_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/webm',
];

// 백엔드는 파일 바이트로 타입을 판별하므로 브라우저별 MIME 변형을 모두 나열
export const ACCEPTED_AUDIO_TYPES = [
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/flac',
  'audio/x-flac',
  'audio/ogg',
  'audio/mp4',
  'audio/x-m4a',
];

export const ACCEPTED_MEDIA_TYPES = [
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_VIDEO_TYPES,
  ...ACCEPTED_AUDIO_TYPES,
];

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
// base64 인코딩 후 10MB 이내에 들어오기 위한 raw 바이트 예산
export const MAX_IMAGE_COMPRESS_TARGET = Math.floor(MAX_IMAGE_SIZE * 0.75);
export const MAX_VIDEO_SIZE = 100 * 1024 * 1024;
export const MAX_MEDIA_SIZE = MAX_VIDEO_SIZE;
export const MAX_VIDEO_DURATION = 180;
// 백엔드가 이 길이 초과분을 절단하여 분석 (거부 아님)
export const MAX_AUDIO_ANALYSIS_DURATION = 300;
